module.exports = __webpack_public_path__ + "static/media/quote-left-solid.75663a15.svg";